<template>
  <div class="edit-container">
    <van-nav-bar :title="`${dailyData.staffName}的日报`" left-arrow @click-left="onClickLeft" />
    <div class="edit-date">
      <span class="edit-label" style="padding:0">日期：{{ reportDateStr }}</span>
      <!-- <a-date-picker v-model="reportDate" placeholder="请选择日期" value-format="YYYY-MM-DD" /> -->
      <div @click="showPicker = true">
        <span style="color: #969799;font-size: .4rem">请选择</span>
        <img style="width: 11px;height:7px" src="../assets/down.png" />
      </div>
    </div>
    <van-popup v-model="showPicker" position="bottom">
      <van-datetime-picker type="date" @confirm="data => onConfirm(data)" @cancel="showPicker = false" v-model="reportDate" />
    </van-popup>
    <div class="edit-label" style="margin-top: 0.43rem">任务打分</div>
    <div style="padding:0.4rem;padding-top:0.27rem">
      <a-collapse :activeKey="activeKey" expand-icon-position="right">
        <a-collapse-panel style="color: #333333" v-for="(i, index) in positionList" :key="String(index)" :header="i.name">
          <div style="margin-bottom: .2rem;padding: 10px;border-top: 1px solid #DADADA;" v-for="(item, index1) in i.duties" :key="item.key">
            <div>岗位职责：{{ item.dutyDesc }}</div>
            <span>任务名称：</span>
            <a-input v-model="item.taskName" :maxLength="50" placeholder="请输入（限50字）" />
            <a @click="deleteTask(index, index1, item)"><img style="width: 22px;height: 24px;margin-left: .1rem" src="../assets/delete@2x.png" /></a>
            <br />
            <span>完成率：</span>
            <a-input-number v-model="item.reachRate" :min="0" :max="100" style="width:20%" />
            %
            <span>任务自评：</span>
            <a-input-number v-model="item.selfComment" :min="0" :max="100" style="width:20%" />
            分
            <br />
            <div><a @click="addTask(index, index1, item)">添加任务</a></div>
          </div>
        </a-collapse-panel>
      </a-collapse>
    </div>
    <span class="edit-label">工作汇报</span>
    <div class="edit-workReport">
      <a-textarea v-model="content" class="ant-textarea" />
    </div>
    <div class="file">
      <span class="edit-label">附件：</span>
      <a-upload name="file" :multiple="true" :action="baseURL" @change="handleChange" :file-list="fileList">
        <a-button>
          <a-icon type="upload" />
          上传
        </a-button>
      </a-upload>
      <div v-for="(item, index) in this.resourcesList" :key="index">
        <div style="display:flex;height: 1rem;margin-left: 0.5rem;">
          <div style="padding-top: 5px;width: 1.3rem;">
            <img style="width: 0.7rem" src="@/assets/file@2x.png" alt="" />
          </div>
          <div style="width:7rem;overflow:hidden;white-space:nowrap;text-overflow:ellipsis;line-height: 1rem;">
            <p style="height: 3px;">{{ item.name + item.suffix }}</p>
          </div>
          <div @click="dele(index, item)" style="line-height: 1rem;">
            删除
          </div>
        </div>
      </div>
    </div>
    <div>
      <div class="edit-label" style="margin-top: 0.27rem">
        汇报给：
        <a-tree-select
          style="width: 183px"
          :dropdown-style="{
            overflow: 'auto'
          }"
          allow-clear
          v-model="approverId"
          :tree-data="addressData"
          :replaceFields="{
            children: 'childList',
            title: 'name',
            key: 'id',
            value: 'id'
          }"
        ></a-tree-select>
      </div>
      <div class="edit-label" style="margin-top: 0.27rem">
        抄送人：
        <a-tree-select
          style="width: 183px"
          :dropdown-style="{
            overflow: 'auto'
          }"
          allow-clear
          multiple
          v-model="copyIds"
          :tree-data="addressData"
          :replaceFields="{
            children: 'childList',
            title: 'name',
            key: 'id',
            value: 'id'
          }"
        ></a-tree-select>
      </div>
      <div class="edit-label" style="margin-top: 0.27rem">
        是否公开：
        <a-switch checked-children="是" un-checked-children="否" v-model="switchValue" @change="onChangeSwitch" />
      </div>
    </div>
    <div class="edit-submit" @click="submitTask">提交</div>
  </div>
</template>

<script>
import { baseURL } from '../axios/index';
import { submitTask, getAddressBook, getIsApproverSet, getTaskDetail, updateTask, supplementTip } from '../axios/services';
import { v4 as uuidv4 } from 'uuid';
import { mapState } from 'vuex';
import { Toast, Dialog } from 'vant';
export default {
  data() {
    return {
      baseURL: baseURL + '/res/upload',
      fileList: [],
      showPicker: false,
      postOption: [
        { text: '全部', value: 0 },
        { text: '已填写', value: 1 },
        { text: '未填写', value: 2 },
        { text: '已审核', value: 3 }
      ],
      postText: '',
      file: [],
      taskData: [],
      activeKey: '',
      reportDate: '', // 日期
      reportDateStr: '',
      content: '', // 详细内容
      resourcesId: '', // 资源id
      sysStaffReportTaskList: [],
      positionList: [],
      switchValue: false,
      approverId: '',
      copyIds: [],
      addressData: [],
      reportId: '',
      companyId: '',
      resourcesList: [],
      supplementTipFlag: false
    };
  },
  computed: {
    ...mapState(['dailyData'])
  },
  watch: {
    file(val) {
      let str = '';
      console.log(val);
      val?.forEach((item, index) => {
        if (index < val.length - 1) {
          str = str + item?.resourcesId + ',';
        } else {
          str = str + item?.resourcesId;
        }
      });
      this.resourcesId = str;
    }
  },
  methods: {
    async supplementTip() {
      const params = {
        companyId: this.dailyData.companyId,
        staffId: this.dailyData.staffId,
        reportDate: this.reportDateStr
      };
      await supplementTip(params).then(res => {
        if (res.data.code === 0) {
          this.supplementTipFlag = res.data.data;
        }
      });
    },
    dele(index, item) {
      this.resourcesList = this.resourcesList.filter(i => i.resourcesId !== item.resourcesId);
    },
    onChangeSwitch(checked) {
      this.switchValue = checked;
    },
    getAddressData() {
      const params = {
        companyId: this.dailyData.companyId
      };
      getAddressBook(params).then(res => {
        if (res.data.code === 0) {
          this.addressData = this.handleDisabled(res.data.data);
        } else {
          Toast.fail(res.data.msg);
        }
      });
    },
    handleDisabled(data) {
      data?.forEach(item => {
        if (item.type !== 2) {
          item.disabled = true;
        } else {
          item.disabled = false;
        }
        if (item.childList && item.childList.length > 0) {
          this.handleDisabled(item.childList);
        }
      });
      return data;
    },

    onConfirm(data) {
      const date = new Date(data);
      const dateTime = date.getFullYear() + '-' + this.checkTime(date.getMonth() + 1) + '-' + this.checkTime(date.getDate());
      this.reportDate = dateTime;
      this.reportDateStr = dateTime;
      this.showPicker = false;
    },
    checkTime(i) {
      if (i < 10) {
        i = '0' + i;
      }
      return i;
    },
    onClickLeft() {
      Dialog.confirm({
        message: '退出后日报内容清空，确定退出当前页面？'
      }).then(() => {
        window.history.go(-1);
      });
    },
    handleChange(info) {
      this.fileList = info.fileList;
      this.file = info.fileList.map(item => item.response?.data);
      console.log(this.file);
    },
    addTask(index, index1, item) {
      let param = Object.assign({}, item);
      console.log(param, 'param');
      for (let m in param) {
        if (m == 'taskName' || m == 'selfComment' || m == 'reachRate') {
          param[m] = '';
        }
      }
      param.key = uuidv4();
      // this.positionList[index].duties.push(param);
      this.positionList[index].duties.splice(index1 + 1, 0, param);
    },
    deleteTask(index, index1, item) {
      console.log(index);
      this.positionList[index].duties = this.positionList[index].duties.filter(i => i.key !== item.key);
    },
    async submitTask() {
      const arr = [];
      let str = '';
      let flag = false;
      for (let i = 0; i < this.positionList.length; i++) {
        this.positionList[i].duties?.forEach(item => {
          arr.push(item);
        });
      }
      arr.forEach(item => {
        if (!item.taskName === '' || item.selfComment == null || item.reachRate == null) {
          Toast('没填写任务名称或者没填写自评分数');
          flag = true;
        }
      });
      if (this.resourcesList) {
        str = this.resourcesList.map(i => {
          return i.resourcesId;
        });
        if (str.length != '') {
          this.resourcesId = this.resourcesId.concat(',', str.toString());
        }
      }
      if (flag) return;
      if (!this.reportDate) return Toast('没有填写日期');
      if (!this.content || this.content == '') return Toast('没有填写工作内容');
      if (!this.approverId) return Toast('没有选择汇报给谁');
      const params = {
        staffId: this.dailyData.staffId,
        staffName: this.dailyData.staffName,
        officeId: this.dailyData.officeId,
        officeName: this.dailyData.officeName,
        companyId: this.dailyData.companyId,
        reportDate: this.reportDateStr,
        resourcesId: this.resourcesId,
        content: this.content,
        reportType: '1',
        sysStaffReportTaskList: arr,
        approverId: this.approverId,
        copyIds: this.copyIds,
        isOpen: this.switchValue === false ? '1' : '0',
        reportId: this.reportId || undefined
      };
      await this.supplementTip();
      let that = this;
      if (!this.supplementTipFlag) {
        return Dialog.confirm({
          message: '已经超过了按时提交的时间，您再次提交会被计算为补交，请确认是否再次提交？',
          confirmButtonText: '是',
          cancelButtonText: '否'
        })
          .then(() => {
            if (that.$route.query.reportId) {
              updateTask(params).then(res => {
                if (res.data.code === 0) {
                  Toast.success('提交成功');
                  setTimeout(() => {
                    window.history.go(-1);
                  }, 500);
                } else {
                  Toast.fail(res.data.msg);
                }
              });
            } else {
              submitTask(params).then(res => {
                if (res.data.code === 0) {
                  Toast.success('提交成功');
                  setTimeout(() => {
                    window.history.go(-1);
                  }, 500);
                } else {
                  Toast.fail(res.data.msg);
                }
              });
            }
          })
          .catch(() => {
            window.history.go(-1);
          });
      }
      if (this.$route.query.reportId) {
        updateTask(params).then(res => {
          if (res.data.code === 0) {
            Toast.success('提交成功');
            setTimeout(() => {
              window.history.go(-1);
            }, 500);
          } else {
            Toast.fail(res.data.msg);
          }
        });
      } else {
        submitTask(params).then(res => {
          if (res.data.code === 0) {
            Toast.success('提交成功');
            setTimeout(() => {
              window.history.go(-1);
            }, 500);
          } else {
            Toast.fail(res.data.msg);
          }
        });
      }
    }
  },
  created() {
    this.companyId = this.$route.query.companyId;
    this.reportId = this.$route.query.reportId;
    console.log(this.reportId, this.companyId);
    if (this.reportId) {
      const params = {
        companyId: this.companyId,
        reportId: this.reportId
      };
      getTaskDetail(params).then(res => {
        if (res.data.code === 0) {
          this.reportDate = res.data.data.reportDate;
          this.content = res.data.data.content;
          this.resourcesList = res.data.data.resourcesList;
          this.status = res.data.data.status;
          this.switchvalue = res.data.data.isOpen == 0 ? true : false;
          this.isRate = res.data.data.isRate;
          this.staffName = res.data.data.staffName;
          this.approverId = res.data.data.approverId;
          this.copyIds = res.data.data.copyIds;
          this.reportId = res.data.data.reportId;
          this.reportDateStr = res.data.data.reportDate;
          this.positionList = res.data.data.sysStaffReportTaskQueryVoList?.map(item => {
            item.name = item.postName;
            if (item.sysStaffReportTaskList !== []) {
              item.duties = item.sysStaffReportTaskList;
              item.duties.forEach(i => {
                console.log(i);
                i.key = uuidv4();
              });
              return { ...item, key: uuidv4() };
            } else {
              return { ...item, key: uuidv4() };
            }
          });
          this.activeKey = this.positionList.map((item, index) => {
            return index;
          });
        } else {
          Toast.fail(res.data.msg);
        }
      });
    } else {
      let date = new Date();
      if (sessionStorage.oldworktime) {
        date = new Date('2024-04-30 00:00:00');
      }
      const dateTime = date.getFullYear() + '-' + this.checkTime(date.getMonth() + 1) + '-' + this.checkTime(date.getDate());
      this.reportDate = new Date();
      this.reportDateStr = dateTime;
      if (this.$route.query.currentDateStr) {
        this.reportDateStr = this.$route.query.currentDateStr;
      } else {
        this.reportDateStr = dateTime;
      }
      this.positionList = this.dailyData.positions?.map(item => {
        if (item.duties !== []) {
          item.duties.forEach(i => {
            i.key = uuidv4();
            i.postName = item.name;
            i.dutyDesc = i.description;
            delete i.description;
          });
          return { ...item, key: uuidv4() };
        } else {
          return { ...item, key: uuidv4() };
        }
      });
      getIsApproverSet(this.dailyData.companyId).then(res => {
        if (res.data.code === 0) {
          this.approverId = res.data.data.approverId;
          this.copyIds = res.data.data.copyIds;
        } else {
          Toast.fail(res.data.msg);
        }
      });
      this.activeKey = this.positionList.map((item, index) => {
        return index;
      });
    }
    this.getAddressData();
  }
};
</script>

<style scoped>
.edit-container {
  width: 100%;
  background: #f9f9f9;
  min-height: 100vh;
  /* padding: .4rem; */
  padding-bottom: 2rem;
  padding-top: 1.17rem;
  position: relative;
}
/deep/ .ant-upload-list-item {
  margin-left: 0.3rem;
}
.edit-container /deep/ .van-nav-bar {
  background: inherit;
  width: 100%;
  height: 1.17rem;
  background: #ffffff;
  position: fixed;
  top: 0;
  left: 0;
}
.van-hairline--bottom::after {
  border: none;
}
.van-nav-bar /deep/ .van-nav-bar__left {
  padding: 0 !important;
}
.van-nav-bar /deep/ .van-nav-bar__arrow {
  font-size: 24px !important;
  color: black;
  padding-left: 0.28rem;
}
.edit-date {
  height: 1.28rem;
  padding: 0.4rem;
  background: #ffffff;
  box-shadow: 0rem 0.05rem 0.11rem 0rem #f2f3f5;
  display: flex;
  justify-content: space-between;
}
.edit-label {
  font-size: 0.43rem;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #323233;
  padding-left: 0.4rem;
}
.ant-collapse-item /deep/.ant-collapse-header {
  width: 100%;
  height: 1rem;
  padding: 0.2rem !important;
  color: inherit;
}
.ant-collapse {
  background: none !important;
}
/* .ant-collapse-item /deep/ .ant-collapse-content {
    background-color: #F2F2F2 !important;
  } */
.ant-collapse-item /deep/ .ant-collapse-content-box {
  padding: 0px !important;
}
.van-dropdown-menu {
  /* width: 1rem; */
  height: 0.8rem;
}
.van-dropdown-menu__item {
  /* width: 1rem; */
  height: 0.8rem;
}
.ant-input {
  width: 60%;
  margin-bottom: 0.2rem;
}
.ant-input-number {
  width: 60%;
  margin-bottom: 0.2rem;
}
/* .edit-workReport {
    width: 100%;
    height: 3rem;
    border: 1px solid #ccc;
  } */
.ant-textarea {
  width: 9.25rem;
  height: 4.8rem;
  background: #ffffff;
  box-shadow: 0rem 0.05rem 0.11rem 0rem #f2f3f5;
  border-radius: 0.21rem;
  margin-top: 0.27rem;
  margin-left: 0.4rem;
  /* border:none; */
}
.edit-submit {
  width: 8.29rem;
  height: 1.17rem;
  background: #1584ff;
  box-shadow: 0rem 0.05rem 0.21rem 0rem #80bcff;
  border-radius: 0.21rem;
  color: white;
  line-height: 1.17rem;
  text-align: center;
  position: fixed;
  bottom: 0.32rem;
  left: 0.85rem;
}
</style>
